import React, { forwardRef, useImperativeHandle, useMemo, useRef, useState } from "react";
import { RCCHookToast, RCCButton, RCCRefModalProps, RCCServicesApi, RCCTooltip, RCCGrid, RCCSwitch, RCCAlert } from "react-common-components";
import { useForm } from "react-hook-form";
import Modal from "src/components/Modal";
import Tabs from "src/components/Tabs";
import Title from "src/components/Title";
import { useLoaderBackdrop } from "src/context/LoaderBackdrop/context";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import formatDate from "src/utils/formatDate";
import stringToNumber from "src/utils/stringToNumber";
import { v4 } from "uuid";
import IFiltersActionsPanel, { ActionGroupers, IGroupersActions, IRefActionsPanelModalAddChangeDelete } from "src/pages/Actions/Panel/interface";
import ModalAddChangeDelete from "src/pages/Actions/Panel/components/modalAddChangeDelete";
import FCA from "src/components/FCA";
import { IFCA, IInternalFCA, IRefComponentFCA } from "src/components/FCA/interface";
import Loader from "src/components/Loader";
import { useConfirmModal } from "src/context/ConfirmModal/context";
import ModalFields from "src/pages/Indicators/Fields/modals";
import { IndicatorFieldType, IRefIndicatorFieldModals } from "src/pages/Indicators/Fields/interface";
import GrouperOfActions from "src/pages/Actions/Panel/grouperOfActions";
import { useAuth } from "src/context/Auth/context";
import { IRefIntegrationsLog } from "src/pages/Config/Integrations/interface";
import ListIntegrationLogs from "src/pages/Config/Integrations/components/listIntegrationLogs";
import { IValuesOfPeriodIndicator, IRefActionsModalValuesOfPeriodIndicators, IIqtbb004, IComponentModalValuesOfPeriodIndicators } from "./interface";
import ValuesIndicator from "./valuesIndicator";
import ValuesImportLogs from "../ListValuesLogs";
import { IRefValuesLogs } from "../ListValuesLogs/interface";

const ModalIndicatorValuesOfPeriod: React.ForwardRefRenderFunction<IRefActionsModalValuesOfPeriodIndicators, IComponentModalValuesOfPeriodIndicators> = ({
	submitMarkToUpdate,
	disabled
}, ref) => {
	const { administrator, superUser } = useAuth();
	const { translate, currentLanguage } = useTranslation();
	const { setLoading } = useLoaderBackdrop();
	const { addToast } = RCCHookToast();
	const { confirm } = useConfirmModal();

	const [fcas, setFcas] = useState<IInternalFCA[]>();

	// Modal Open Values of Period
	const modalOpenValuesOfPeriod = useRef<RCCRefModalProps>(null);
	// Modal fields
	const modalFieldsRef = useRef<IRefIndicatorFieldModals>(null);
	// Modal integration logs
	const integrationLogsRef = useRef<IRefIntegrationsLog>(null);
	// Actions
	const modalsRef = useRef<IRefActionsPanelModalAddChangeDelete>(null);
	const [loadedActions, setLoadedActions] = useState(false);
	const [loadingActions, setLoadingActions] = useState(true);
	const [grouperData, setGrouperData] = useState<IGroupersActions[]>([]);
	const [isPresentation, setIsPresentation] = useState(false);

	const loadGroupers = async () => {
		try{
			setLoadingActions(true);

			const {data} = await RCCServicesApi.getRequest({
				method: "Actions/ListGroupers",
				urlParameters: {
					group: ActionGroupers.FCA,
					delayed: "",
					origin: "",
					situation: null,
					startDate: "",// formatDate(header.iqb004Dataini, currentLanguage),
					startPerc: 0,
					endPerc: 100,
					// id: periodId.current,
					id2: indicatorId.current,
					id4: formatDate(header.iqb004Datafim)
				}
			});

			const groupersFromDB: IGroupersActions[] = data;
					
			setGrouperData(groupersFromDB);

			setLoadingActions(false);
		}catch(err){
			standardErrorMessages(err, translate("Erro ao carregar os agrupadores"), addToast);
			setLoadingActions(false);
		}
	};
	const GroupersActions = useMemo(() => <>
		{loadingActions ? <Loader /> : (
			<>
				{!grouperData || grouperData.length === 0 ? (
					<RCCAlert 
						title={translate("Atenção")}
						description={translate("Nenhum agrupador encontrado")}
					/>
				): (
					<>
						{grouperData.map((grouper) => (
							<GrouperOfActions 
								key={`${grouper.id}-${grouper.id2}-${grouper.id3}-${grouper.id4}-grouper-actions`}
								filters={{} as IFiltersActionsPanel}
								grouper={grouper}
								groupersSelect={{
									group: ActionGroupers.FCA,
									delayed: "",
									origin: ""
								}}
								layoutList="card"
								onCallbackAdd={() => {}}
							/>
						))}
					</>
				)}
			</>
		)}
	</>, [grouperData, loadingActions]);
	// FCA
	const fcaRef = useRef<IRefComponentFCA>(null);
	const [loadedFCA, setLoadedFCA] = useState(false);
	// Load of change period
	const [loadChangePeriod, setLoadChangePeriod] = useState(false);
	// value logs
	const [loadedLogs, setloadedLogs] = useState(false);
	const logsRef = useRef<IRefValuesLogs>(null);

	const [valuesOfPeriodIndicator, setValuesOfPeriodIndicator] = useState<IValuesOfPeriodIndicator | undefined>(undefined);
	const indicatorId = useRef<number>(0);
	const periodId = useRef<number>(0);
	const onCallbackFunction = useRef<Function | undefined>(undefined);
	const [header, setHeader] = useState<IIqtbb004>({} as IIqtbb004);
	const [subtitle, setSubtitle] = useState("");
	const hasChangedValues = useRef(false);
	const onCloseFunction = useRef<Function | undefined> (undefined);
	const { register: registerValuesOfPeriod, control: controlValuesOfPeriod, reset: resetValuesOfPeriod, handleSubmit: handleSubmitValuesOfPeriod } = useForm();

	const permissionToEditValues = !disabled && (administrator || superUser || (valuesOfPeriodIndicator && valuesOfPeriodIndicator?.permission >= 3));
	const permissionToDoFCA = !disabled && (administrator || superUser || (valuesOfPeriodIndicator && valuesOfPeriodIndicator?.permission >= 2));

	const actionButtonOpenValuesOfPeriodIndicators = async (id: number, title: string, periodIdVal: any, onCallback?: Function, presentation?: boolean) => {
		
		setIsPresentation(presentation ?? false);


		const newPeriodId = periodIdVal?.periodId || periodIdVal; 

		async function executeOpen() {
		
			setLoading(true);
			resetValuesOfPeriod();

			indicatorId.current = id;
			periodId.current = newPeriodId;
			onCallbackFunction.current = onCallback;
			onCloseFunction.current = undefined;

			const {data} = await RCCServicesApi.getRequest({
				method: "Indicators/GetIndicatorValuesOfPeriod",
				urlParameters: {
					id,
					periodId: newPeriodId
				}
			});
			
			setValuesOfPeriodIndicator(data as IValuesOfPeriodIndicator);
			setHeader(data.values[0].iqtbb004);
	
			if(initialTab(data?.permission) === 1 || presentation)
				await executeQueryFCAS(indicatorId.current, periodId.current);

			hasChangedValues.current = false;
			setLoading(false);
			modalOpenValuesOfPeriod.current?.openModal();
		}
		try{
			setSubtitle(title);
			setLoadedActions(false);
			setLoadedFCA(false);
			setloadedLogs(false);
			await executeOpen();	
		}catch(err){
			standardErrorMessages(err, translate("Erro ao buscar os valores do período"), addToast);
			setLoading(false);
		}
	};

	const executeQueryFCAS = async (id: number, id2: number) => {
		try{
			setLoading(true);
			const {data} = await RCCServicesApi.getRequest({
				method: "FCA/List",
				urlParameters: {
					id,
					id2: id2 || "",
					tablesRelated: 1
				}
			});
		
			const fcasFromDB = data as IFCA[];
			setFcas(fcasFromDB.length === 1 ? [{...fcasFromDB[0], expanded: true, id: disabled ? "disabled" : v4()}] : fcasFromDB.map((fca) => ({
				...fca,
				id: disabled ? "disabled" : v4()  
			})));
			setLoading(false);
		}catch(err){
			setLoading(false);
			standardErrorMessages(err, translate("Erro ao listar FCA"), addToast);
		}
	};

	const executeSubmit = async (data: any) => {
		setLoading(true);

		// Filter is for -> if you don't have the Compare with Goal field Inserted and the User Did not Change Value (or Link or Comment), it does not insert
		const dataFormat = {
			iqc006Habilitado: !permissionToEditValues ? valuesOfPeriodIndicator?.isEnabled : data.iqc006Habilitado,
			val: data?.val?.filter((x: any) => !(Number(x.iqd001Id) === 0 && x.iqd001Valor === undefined && String(x.iqd001Comentario).length === 0 && String(x.iqd001Linkexterno).length === 0)).map((dt: any) => ({
				iqd001Comentario: dt.iqd001Comentario,
				iqd001Id: Number(dt.iqd001Id),
				iqd001Linkexterno: dt.iqd001Linkexterno,
				iqd001Valor: stringToNumber(dt.iqd001Valor, currentLanguage),
				iqd001Iqb001Id: dt.iqb001Id
			}))
		};
	
		await RCCServicesApi.postRequest({
			method: "Indicators/InsertIndicatorValuesOfPeriod",
			body: {
				id: indicatorId.current,
				indicatorName: subtitle,
				periodId: periodId.current,
				...dataFormat
			}
		});
	
		addToast({
			color: "green",
			description: translate("Valores do período atualizados com sucesso"),
			title: translate("Sucesso")
		});
		hasChangedValues.current = false;		
		setLoading(false);
	};
	const onSubmitValuesOfPeriodIndicators = async (data: any) => {
		try{
			await executeSubmit(data);
			window.setTimeout(() => {  
				if(onCallbackFunction.current) onCallbackFunction.current(); 
			}, 200); 
			modalOpenValuesOfPeriod.current?.closeModal();
		}catch(err){
			standardErrorMessages(err, translate("Erro ao inserir os valores do período"), addToast);
			setLoading(false);
		}
		
	};
	const changePeriod = async (id: number) => {
		try{
			setLoadChangePeriod(true);
			periodId.current = id;
			setLoadedActions(false);
			setLoadedFCA(false);
			setloadedLogs(false);
			resetValuesOfPeriod();
			
			const {data} = await RCCServicesApi.getRequest({
				method: "Indicators/GetIndicatorValuesOfPeriod",
				urlParameters: {
					id: indicatorId.current,
					periodId: id
				}
			});

			if(initialTab(data?.permission) === 1 || isPresentation)
				await executeQueryFCAS(indicatorId.current, periodId.current);
			
			setValuesOfPeriodIndicator(data as IValuesOfPeriodIndicator);
			setHeader(data.values[0].iqtbb004);
			setLoadChangePeriod(false);
			hasChangedValues.current = false;
		}catch(err){
			standardErrorMessages(err, translate("Erro ao buscar os valores do período"), addToast);
		}
	};
	const navigateThroughNextOrPrevPeriod = async (idOfPeriod: number | null) => {
		if(idOfPeriod === null)
			return;
		 if(hasChangedValues.current){
			await confirm(
				translate("Salvar alterações"), 
				`${translate("Deseja realmente salvar as alterações feitas")}?`,
				handleSubmitValuesOfPeriod(async (data: any) => {
					await executeSubmit(data);
					changePeriod(idOfPeriod);
					onCloseFunction.current = onCallbackFunction.current;
				}),
				(err) => {
					standardErrorMessages(err, translate("Erro ao inserir os valores do período"), addToast);
					setLoading(false);
				},
				true,
				() => changePeriod(idOfPeriod)
			);	
		 }
		 else{
			 changePeriod(idOfPeriod); 
		 }
	};
	const changeValue = () => { hasChangedValues.current = true; };

	const initialTab = (defaultValue?: number) => {
		if(defaultValue && defaultValue === 2)
			return 1;
		if(valuesOfPeriodIndicator?.permission === 2)
			return 1;
		if(disabled || isPresentation)
			return 1;
		return 0;
	};
	useImperativeHandle(ref, () => ({
		actionButtonOpenValuesOfPeriodIndicators
	}));
    
	if(!valuesOfPeriodIndicator)
		return null;

	return (
		<>		
			{/* Modal Values of Period INDICATOR */}
			<Modal
				ref={modalOpenValuesOfPeriod}
				header={{
					title: translate("Valores do período"),
					subtitle: `${translate("Indicador")}: ${subtitle}`,
					icon: {
						name: "list"
					}
				}}
				styleInline="width: 95vw;"
				onSubmit={handleSubmitValuesOfPeriod(onSubmitValuesOfPeriodIndicators)}
				onClose={() => {
					if(onCloseFunction.current)
						onCloseFunction.current();
				}}
				footer={{
					showSaveButton: !disabled && !isPresentation,
					buttonLoadingText: translate("Carregando"),
					saveButtonText: translate("Salvar"),
					cancelButtonText: translate("Cancelar")
				}}
				withoutForm
			>
				{loadChangePeriod ? <Loader /> : (
					<>
						<RCCGrid
							container 
							item
							justifyContent="space-between"
						>
							<RCCTooltip
								color="purple"
								text={translate("Período anterior")}
								position="right"
							>
								<RCCButton 
									color="transparent"
									icon={{
										name: "arrowLeft",
										color: "var(--purple-lighter)",
										size: 22
									}}
									disabled={valuesOfPeriodIndicator.previousPeriodId === null}
									onClick={() => navigateThroughNextOrPrevPeriod(valuesOfPeriodIndicator.previousPeriodId)}
								/>
							</RCCTooltip>
							{!permissionToEditValues ? (
								<Title 
									color="purple" 
									size="md" 
								>
									{translate("Período")}: {header.iqb004Descricao} ({formatDate(header.iqb004Dataini, currentLanguage)} - {formatDate(header.iqb004Datafim, currentLanguage)})
								</Title>
							) : (
								<RCCTooltip
									text={translate("Marcar para atualizar")}
									color="purple"
									position="bottom"
								>
									<Title 
										color="purple"
										size="md" 
										onClick={() => submitMarkToUpdate && submitMarkToUpdate(indicatorId.current, subtitle, valuesOfPeriodIndicator.baseYear !== null ? String(valuesOfPeriodIndicator.baseYear) : String(new Date().getFullYear()), header.iqb004Id)}
										styleInline="&:hover{ text-decoration: underline; cursor: pointer; }"
									>
										{translate("Período")}: {header.iqb004Descricao} ({formatDate(header.iqb004Dataini, currentLanguage)} - {formatDate(header.iqb004Datafim, currentLanguage)})
									</Title>
								</RCCTooltip>
							)}
							<RCCTooltip
								color="purple"
								text={translate("Próximo período")}
								position="left"
							>
								<RCCButton 
									color="transparent"
									icon={{
										name: "arrowRight",
										color: "var(--purple-lighter)",
										size: 22
									}}
									disabled={valuesOfPeriodIndicator.nextPeriodId === null}
									onClick={() => navigateThroughNextOrPrevPeriod(valuesOfPeriodIndicator.nextPeriodId)}
								/>
							</RCCTooltip>
						</RCCGrid>
						<Tabs 
							name="TabsIndicatorsValuesOfPeriod"
							tabInit={initialTab()}
							styleInline="height: calc(100% - 36px);"
							options={[{
								label: translate("Valores"),
								hidden: !permissionToEditValues || isPresentation,
								content: <RCCGrid 
									container 
									item
									direction="column"
									alignItems="center"
								>		
									<RCCGrid
										container
										item
										xs={12}
										sm={10}
										md={8}
									>
										<RCCSwitch
											name="iqc006Habilitado"
											label={translate("Considerar período no cálculo")}
											register={registerValuesOfPeriod}
											defaultChecked={valuesOfPeriodIndicator.isEnabled}
											onChangeCapture={changeValue}
										/>
									</RCCGrid>
							
									<RCCGrid
										container
										item
										xs={12}
										sm={10}
										md={8}
									>
										{valuesOfPeriodIndicator.values.map((val, index) => (
											<ValuesIndicator 
												key={v4()}
												id={val.iqd001Id || 0}
												fieldId={val.iqtbb001.iqb001Id}
												comment={val.iqd001Comentario}
												control={controlValuesOfPeriod}
												index={index}
												label={val.iqb001Label}
												link={val.iqd001Linkexterno}
												register={registerValuesOfPeriod}
												isGoal={val.iqtbb001.iqb001Meta === "S"}
												isCompareGoal={val.iqtbc002.iqc002Compararmeta === "S"}
												value={val.iqd001Valor}
												formula={val.formula}
												formulaType={val.formulaType?.toString() as IndicatorFieldType}
												onChange={changeValue}
												permission={valuesOfPeriodIndicator.permission}
												openChangeField={() => {
													modalFieldsRef.current?.actionButtonChange({
														iqb001Id: val.iqtbb001.iqb001Id,
														iqb001Codigo: "",
														iqb001Descricao: "",
														iqb001Label: ""
													}, () => {
														changePeriod(periodId.current);
													});
												}}
												openIntegrationLogs={() => {
													integrationLogsRef.current?.actionButtonOpen(val.iqtbb001.iqb001Id, val.iqb001Label);
												}}
												decimalPlaces={val.iqtbb001.iqb001Casasdecimais}
											/>
										))}
									</RCCGrid>
								
								</RCCGrid>
							}, {
								label: "FCA",
								content: <FCA 
									ref={fcaRef}
									id={indicatorId.current}
									id2={periodId.current}
									tablesRelated={1}
									defaultValue={fcas}
									isPresentation={isPresentation}
								/>,
								onClick: () => {
									if(loadedFCA)
										return;
									fcaRef.current?.executeQuery();
									setLoadedFCA(true);
									setLoadedActions(false);
								},
								hidden: !permissionToDoFCA && !isPresentation
							}, {
								label: translate("Ações"),
								content: GroupersActions,
								onClick: async () => {
									if(loadedActions)
										return;
									await loadGroupers();
									setLoadedActions(true);
									setLoadedFCA(false);
								}
							}, {
								label: translate("Logs"),
								content: <ValuesImportLogs
									ref={logsRef} 
									iqb004Id={periodId.current}  
									iqc001Id={indicatorId.current}
								/>,
								onClick: async () => {
									if(loadedLogs)
										return;
									logsRef.current?.executeQuery();
									setloadedLogs(true);
								},
								hidden: isPresentation
							}]}
						/>
					</>
				)}
			</Modal>

			{/* Modal ADD inside risk analysis */}
			<ModalAddChangeDelete ref={modalsRef} />

			{/* Modal change field */}
			<ModalFields ref={modalFieldsRef} />

			{/* Modal integration log */}
			<ListIntegrationLogs ref={integrationLogsRef}/>
		</>
	);
};

export default forwardRef(ModalIndicatorValuesOfPeriod);
